import { c as _c } from "react/compiler-runtime";
import React from "react";
import PrimaryButton from "@/components/utils/button/PrimaryButton";
import type { ApiWave } from "@/generated/models/ApiWave";
import AgreementStepAgreement from "./AgreementStepAgreement";
interface AgreementStepProps {
  readonly wave: ApiWave;
  readonly agreements: boolean;
  readonly setAgreements: (agreed: boolean) => void;
  readonly onContinue: () => void;
}
const AgreementStep: React.FC<AgreementStepProps> = t0 => {
  const $ = _c(27);
  const {
    wave,
    agreements,
    setAgreements,
    onContinue
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="tw-mt-6 tw-max-w-4xl tw-space-y-2 tw-text-base tw-text-iron-300"><p className="tw-mb-0">Before you submit your work to The Memes, we would like to make sure we are all on the same page about what this means for you and your work!</p><p className="tw-mb-0">Please read the important information below and confirm that you understand and agree. If you have any questions, please reach out to one of the team members before you submit!</p></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = wave.participation.terms ?? "";
  let t3;
  if ($[1] !== t2) {
    t3 = <div className="tw-flex-1 tw-overflow-y-auto tw-overflow-x-hidden tw-px-4 tw-pb-6 tw-pt-2 tw-scrollbar-thin tw-scrollbar-track-iron-800 tw-scrollbar-thumb-iron-500 desktop-hover:hover:tw-scrollbar-thumb-iron-300 md:tw-px-8"><div className="tw-mx-auto tw-max-w-5xl">{t1}<div className="tw-mt-6 tw-flex tw-flex-col tw-rounded-xl tw-bg-iron-900 tw-p-4 tw-ring-1 tw-ring-iron-800 lg:tw-p-6"><AgreementStepAgreement text={t2} /></div></div></div>;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== agreements || $[4] !== setAgreements) {
    t4 = () => setAgreements(!agreements);
    $[3] = agreements;
    $[4] = setAgreements;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = agreements ? "Uncheck terms agreement" : "Check terms agreement";
  const t6 = `tw-h-5 tw-w-5 tw-flex-shrink-0 tw-rounded tw-border tw-border-solid tw-transition-all tw-duration-300 ${agreements ? "tw-border-primary-500 tw-bg-primary-500 tw-shadow-[0_0_0_4px_rgba(139,92,246,0.1)]" : "tw-border-iron-700 tw-bg-iron-800"} tw-flex tw-items-center tw-justify-center`;
  let t7;
  if ($[6] !== agreements) {
    t7 = agreements && <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" className="tw-h-3 tw-w-3 tw-flex-shrink-0 tw-text-white" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" /></svg>;
    $[6] = agreements;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t6 || $[9] !== t7) {
    t8 = <div className={t6}>{t7}</div>;
    $[8] = t6;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const t9 = `tw-text-sm tw-font-medium tw-transition-colors ${agreements ? "tw-text-iron-100" : "tw-text-iron-300"}`;
  let t10;
  if ($[11] !== t9) {
    t10 = <span className={t9}>I have read and understood the above and will certify it with a signature from my wallet.</span>;
    $[11] = t9;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== t10 || $[14] !== t4 || $[15] !== t5 || $[16] !== t8) {
    t11 = <button onClick={t4} className="tw-flex tw-flex-1 tw-items-start tw-gap-3 tw-rounded-lg tw-border-none tw-bg-iron-900/50 tw-px-4 tw-py-3 tw-text-left tw-ring-1 tw-ring-iron-800 tw-transition-all desktop-hover:hover:tw-ring-iron-700" aria-label={t5}>{t8}{t10}</button>;
    $[13] = t10;
    $[14] = t4;
    $[15] = t5;
    $[16] = t8;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  const t12 = !agreements;
  let t13;
  if ($[18] !== onContinue || $[19] !== t12) {
    t13 = <PrimaryButton onClicked={onContinue} loading={false} disabled={t12} padding="tw-px-6 tw-py-3">{"I Agree & Continue"}</PrimaryButton>;
    $[18] = onContinue;
    $[19] = t12;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== t11 || $[22] !== t13) {
    t14 = <div className="tw-border-x-0 tw-border-b-0 tw-border-t tw-border-solid tw-border-iron-800 tw-bg-iron-950"><div className="tw-px-4 tw-py-4 md:tw-px-8"><div className="tw-mx-auto tw-flex tw-max-w-5xl tw-flex-col tw-items-center tw-justify-between tw-gap-4 md:tw-flex-row">{t11}{t13}</div></div></div>;
    $[21] = t11;
    $[22] = t13;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== t14 || $[25] !== t3) {
    t15 = <div className="tw-relative tw-flex tw-h-full tw-flex-col">{t3}{t14}</div>;
    $[24] = t14;
    $[25] = t3;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  return t15;
};
export default AgreementStep;